<template>
  <component :is="asset" class="svg-icon" :style="style" />
</template>

<script>
import tools from '@/mixin/tools'

export default {
  name: 'FunnowSvgIcon',
  mixins: [tools],
  props: {
    imagePath: { type: String, default: '' },
    maxWidth: { type: [String, Number], default: '20' },
    height: { type: [String, Number], default: '' },
    color: { type: String, default: '' },
  },
  setup(props) {
    const iconPath = computed(() => `/images/icon/${props.imagePath}`)
    const asset = useAsset(iconPath)

    return {
      asset,
    }
  },
  data() {
    return {}
  },
  computed: {
    style() {
      const style = {
        width: '100%',
      }
      if (this.maxWidth) {
        style.maxWidth = `${this.maxWidth}px`
      }
      if (this.height) {
        style.height = `${this.height}px`
      }
      if (this.color) {
        style.color = this.color
      }
      return style
    },
  },
}
</script>
<style lang="scss" scoped>
.svg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
svg {
  vertical-align: middle;
}
</style>
